module.exports = __webpack_public_path__ + "img/logo_QQ.b3d49820.png";